import React, { useEffect, useState } from 'react';
import './App.css';
import Table, { PickedFood } from './Table';
import Help from './Help';

const FOODS_STORAGE_KEY = 'food-tagger:foods';

function loadSavedFoods(): PickedFood[] {
  try {
    const saved = JSON.parse(localStorage.getItem(FOODS_STORAGE_KEY) ?? '[]');
    return Array.isArray(saved) ? saved : [];
  } catch {
    return [];
  }
}

function App() {
  const [showHelp, setShowHelp] = useState(false);
  const [foods, setFoods] = useState<PickedFood[]>(loadSavedFoods);

  useEffect(() => {
    localStorage.setItem(FOODS_STORAGE_KEY, JSON.stringify(foods));
  }, [foods]);

  return (
    <div className="App">
      <header className="App-header">
        <div></div>
        O Fazedor de etiquetas de comida
        <div className="App-header-help">
          <button
            className="App-header-help-button"
            onClick={() => setShowHelp(h => !h)}
          >
            {showHelp ? 'voltar' : 'ajuda'}
          </button>
        </div>
      </header>
      {showHelp ? <Help /> : <Table foods={foods} setFoods={setFoods} />}
    </div>
  );
}

export default App;
